var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoNumericWidget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_numeric",
    transform: "translate(-1281.416 -234.416)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 32,
    height: 32,
    transform: "rotate(90 539.5 773.916)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Green_Bg",
    "data-name": "Green Bg",
    width: 26,
    height: 26,
    rx: 4,
    transform: "translate(1284.416 237.416)",
    fill: "#06c270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "#",
    d: "M9.231,13.156H5.7a.053.053,0,0,0-.052.041L4.826,16.86a.054.054,0,0,1-.063.04l-2.3-.448a.052.052,0,0,1-.042-.062l.7-3.175a.052.052,0,0,0-.052-.063H.053A.053.053,0,0,1,0,13.1V10.867a.053.053,0,0,1,.054-.052H3.569a.053.053,0,0,0,.052-.041L4.69,6.161A.053.053,0,0,0,4.637,6.1H1.261a.053.053,0,0,1-.054-.052V3.808a.053.053,0,0,1,.054-.052H5.141a.053.053,0,0,0,.052-.041L6.022.043A.054.054,0,0,1,6.085,0l2.3.446a.052.052,0,0,1,.042.064L7.615,3.679a.052.052,0,0,0,.052.065h3.526a.053.053,0,0,0,.052-.041L12.07.042A.054.054,0,0,1,12.133,0l2.3.447a.052.052,0,0,1,.042.062l-.7,3.175a.053.053,0,0,0,.052.063h3.013A.053.053,0,0,1,16.9,3.8V6.036a.053.053,0,0,1-.054.052H13.327a.053.053,0,0,0-.052.041L12.207,10.74a.052.052,0,0,0,.052.063h3.373a.053.053,0,0,1,.054.052v2.237a.053.053,0,0,1-.054.052H11.755a.053.053,0,0,0-.052.041l-.829,3.674a.054.054,0,0,1-.063.04l-2.3-.447a.052.052,0,0,1-.042-.064l.814-3.168a.052.052,0,0,0-.052-.065m-3.19-2.416a.052.052,0,0,0,.046.064l.04,0c1.133,0,2.266,0,3.4,0,.131,0,.154-.062.178-.159q.45-1.76.9-3.519.125-.486.247-.973a.051.051,0,0,0-.041-.063h-.005c-1.152,0-2.3,0-3.455-.006-.127,0-.137.073-.159.158q-.3,1.164-.6,2.328c-.184.715-.366,1.431-.554,2.162",
    transform: "translate(1288.965 241.963)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoNumericWidget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_numeric_widget.2c2cd32a7ea77f3aea5d8c68ff809bc2.svg";